import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "./UserContext";

const ClientRoute: React.FC = () => {
  const { getUser } = useUserContext();
  const user = getUser();

  if (!user?.idCliente) {
    return <Navigate to="/mainpage" replace />;
  }

  return <Outlet />;
};

export default ClientRoute;
